export default {
  SUM: 'Sum',
  SEND_WITH_SMS: 'sms',
  SEND_WITH_EMAIL: 'email',
  ADVANCED_ALERT: 'advanced',
  PREDEFINED_ALERT: 'predefined'
};
